/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GrantedSettlement } from './GrantedSettlement';
import {
    GrantedSettlementFromJSON,
    GrantedSettlementFromJSONTyped,
    GrantedSettlementToJSON,
    GrantedSettlementToJSONTyped,
} from './GrantedSettlement';
import type { PreferredSettlement } from './PreferredSettlement';
import {
    PreferredSettlementFromJSON,
    PreferredSettlementFromJSONTyped,
    PreferredSettlementToJSON,
    PreferredSettlementToJSONTyped,
} from './PreferredSettlement';
import type { ProductClaimAttachment } from './ProductClaimAttachment';
import {
    ProductClaimAttachmentFromJSON,
    ProductClaimAttachmentFromJSONTyped,
    ProductClaimAttachmentToJSON,
    ProductClaimAttachmentToJSONTyped,
} from './ProductClaimAttachment';
import type { ProductClaimConversation } from './ProductClaimConversation';
import {
    ProductClaimConversationFromJSON,
    ProductClaimConversationFromJSONTyped,
    ProductClaimConversationToJSON,
    ProductClaimConversationToJSONTyped,
} from './ProductClaimConversation';
import type { ProductClaimProcessingStatus } from './ProductClaimProcessingStatus';
import {
    ProductClaimProcessingStatusFromJSON,
    ProductClaimProcessingStatusFromJSONTyped,
    ProductClaimProcessingStatusToJSON,
    ProductClaimProcessingStatusToJSONTyped,
} from './ProductClaimProcessingStatus';
import type { HeoTransactionNumber } from './HeoTransactionNumber';
import {
    HeoTransactionNumberFromJSON,
    HeoTransactionNumberFromJSONTyped,
    HeoTransactionNumberToJSON,
    HeoTransactionNumberToJSONTyped,
} from './HeoTransactionNumber';
import type { ProductClaimReason } from './ProductClaimReason';
import {
    ProductClaimReasonFromJSON,
    ProductClaimReasonFromJSONTyped,
    ProductClaimReasonToJSON,
    ProductClaimReasonToJSONTyped,
} from './ProductClaimReason';

/**
 * 
 * @export
 * @interface ProductClaimDetailProjection
 */
export interface ProductClaimDetailProjection {
    /**
     * 
     * @type {string}
     * @memberof ProductClaimDetailProjection
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof ProductClaimDetailProjection
     */
    number?: number;
    /**
     * 
     * @type {Date}
     * @memberof ProductClaimDetailProjection
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ProductClaimDetailProjection
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof ProductClaimDetailProjection
     */
    description: string;
    /**
     * 
     * @type {GrantedSettlement}
     * @memberof ProductClaimDetailProjection
     */
    grantedSettlement?: GrantedSettlement;
    /**
     * 
     * @type {PreferredSettlement}
     * @memberof ProductClaimDetailProjection
     */
    preferredSettlement: PreferredSettlement;
    /**
     * 
     * @type {ProductClaimProcessingStatus}
     * @memberof ProductClaimDetailProjection
     */
    processingStatus: ProductClaimProcessingStatus;
    /**
     * 
     * @type {number}
     * @memberof ProductClaimDetailProjection
     */
    deliveryDeviation?: number;
    /**
     * 
     * @type {ProductClaimReason}
     * @memberof ProductClaimDetailProjection
     */
    reason: ProductClaimReason;
    /**
     * 
     * @type {string}
     * @memberof ProductClaimDetailProjection
     */
    serialNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ProductClaimDetailProjection
     */
    productNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ProductClaimDetailProjection
     */
    productName: string;
    /**
     * 
     * @type {HeoTransactionNumber}
     * @memberof ProductClaimDetailProjection
     */
    invoiceNumber: HeoTransactionNumber;
    /**
     * 
     * @type {Date}
     * @memberof ProductClaimDetailProjection
     */
    invoiceCreatedAt: Date;
    /**
     * 
     * @type {ProductClaimDetailProjectionTicketSystemEnum}
     * @memberof ProductClaimDetailProjection
     */
    ticketSystem: ProductClaimDetailProjectionTicketSystemEnum;
    /**
     * 
     * @type {number}
     * @memberof ProductClaimDetailProjection
     */
    creditNoteNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductClaimDetailProjection
     */
    rmaNumber?: number;
    /**
     * 
     * @type {Array<ProductClaimAttachment>}
     * @memberof ProductClaimDetailProjection
     */
    attachments: Array<ProductClaimAttachment>;
    /**
     * 
     * @type {Array<ProductClaimConversation>}
     * @memberof ProductClaimDetailProjection
     */
    conversations: Array<ProductClaimConversation>;
}


/**
 * @export
 */
export const ProductClaimDetailProjectionTicketSystemEnum = {
    Freshdesk: 'FRESHDESK',
    Hubspot: 'HUBSPOT'
} as const;
export type ProductClaimDetailProjectionTicketSystemEnum = typeof ProductClaimDetailProjectionTicketSystemEnum[keyof typeof ProductClaimDetailProjectionTicketSystemEnum];


/**
 * Check if a given object implements the ProductClaimDetailProjection interface.
 */
export function instanceOfProductClaimDetailProjection(value: object): value is ProductClaimDetailProjection {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('preferredSettlement' in value) || value['preferredSettlement'] === undefined) return false;
    if (!('processingStatus' in value) || value['processingStatus'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('serialNumber' in value) || value['serialNumber'] === undefined) return false;
    if (!('productNumber' in value) || value['productNumber'] === undefined) return false;
    if (!('productName' in value) || value['productName'] === undefined) return false;
    if (!('invoiceNumber' in value) || value['invoiceNumber'] === undefined) return false;
    if (!('invoiceCreatedAt' in value) || value['invoiceCreatedAt'] === undefined) return false;
    if (!('ticketSystem' in value) || value['ticketSystem'] === undefined) return false;
    if (!('attachments' in value) || value['attachments'] === undefined) return false;
    if (!('conversations' in value) || value['conversations'] === undefined) return false;
    return true;
}

export function ProductClaimDetailProjectionFromJSON(json: any): ProductClaimDetailProjection {
    return ProductClaimDetailProjectionFromJSONTyped(json, false);
}

export function ProductClaimDetailProjectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductClaimDetailProjection {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'number': json['number'] == null ? undefined : json['number'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'description': json['description'],
        'grantedSettlement': json['grantedSettlement'] == null ? undefined : GrantedSettlementFromJSON(json['grantedSettlement']),
        'preferredSettlement': PreferredSettlementFromJSON(json['preferredSettlement']),
        'processingStatus': ProductClaimProcessingStatusFromJSON(json['processingStatus']),
        'deliveryDeviation': json['deliveryDeviation'] == null ? undefined : json['deliveryDeviation'],
        'reason': ProductClaimReasonFromJSON(json['reason']),
        'serialNumber': json['serialNumber'],
        'productNumber': json['productNumber'],
        'productName': json['productName'],
        'invoiceNumber': HeoTransactionNumberFromJSON(json['invoiceNumber']),
        'invoiceCreatedAt': (new Date(json['invoiceCreatedAt'])),
        'ticketSystem': json['ticketSystem'],
        'creditNoteNumber': json['creditNoteNumber'] == null ? undefined : json['creditNoteNumber'],
        'rmaNumber': json['rmaNumber'] == null ? undefined : json['rmaNumber'],
        'attachments': ((json['attachments'] as Array<any>).map(ProductClaimAttachmentFromJSON)),
        'conversations': ((json['conversations'] as Array<any>).map(ProductClaimConversationFromJSON)),
    };
}

export function ProductClaimDetailProjectionToJSON(json: any): ProductClaimDetailProjection {
    return ProductClaimDetailProjectionToJSONTyped(json, false);
}

export function ProductClaimDetailProjectionToJSONTyped(value?: ProductClaimDetailProjection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'number': value['number'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'description': value['description'],
        'grantedSettlement': GrantedSettlementToJSON(value['grantedSettlement']),
        'preferredSettlement': PreferredSettlementToJSON(value['preferredSettlement']),
        'processingStatus': ProductClaimProcessingStatusToJSON(value['processingStatus']),
        'deliveryDeviation': value['deliveryDeviation'],
        'reason': ProductClaimReasonToJSON(value['reason']),
        'serialNumber': value['serialNumber'],
        'productNumber': value['productNumber'],
        'productName': value['productName'],
        'invoiceNumber': HeoTransactionNumberToJSON(value['invoiceNumber']),
        'invoiceCreatedAt': value['invoiceCreatedAt'].toISOString(),
        'ticketSystem': value['ticketSystem'],
        'creditNoteNumber': value['creditNoteNumber'],
        'rmaNumber': value['rmaNumber'],
        'attachments': ((value['attachments'] as Array<any>).map(ProductClaimAttachmentToJSON)),
        'conversations': ((value['conversations'] as Array<any>).map(ProductClaimConversationToJSON)),
    };
}

